import React, { useState } from "react";
import { Dialog } from "@lmn/design-system";
import styled from "styled-components";

const TriggerContainer = styled.span(() => ({
  width: "fit-content",
  display: "inline-flex",
  cursor: "pointer",
  verticalAlign: "middle",
  // todo: add hover effect to the trigger
}));

type DialogTooltipProps = {
  trigger: React.ReactElement;
  content: React.ReactNode;
  title?: string;
  className?: string;
};

const DialogTooltip = ({
  trigger,
  content,
  title,
  className,
  ...props
}: DialogTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <TriggerContainer {...props} className={className} onClick={handleOpen}>
        {trigger}
      </TriggerContainer>
      <Dialog
        isOpen={isOpen}
        onClose={handleClose}
        {...(title && {
          header: {
            title,
            sticky: true,
          },
        })}
      >
        {content}
      </Dialog>
    </>
  );
};

export default DialogTooltip;
